/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.blockchain_address', [
      'admin.users.details.blockchain_address.service'
    ])
    .controller('BlockchainAddressCtrl', BlockchainAddressCtrl);

  /** @ngInject */
  function BlockchainAddressCtrl($stateParams, BlockchainAddressService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    BlockchainAddressService.list(vm.userId).then(function(result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(result.results[i]['ts-m'] / 1000);
      }
      vm.items = result.results;
    });
  }

})();
